/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WednesdayInputs */

const en_wednesday = /** @type {(inputs: WednesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wednesday`)
};

const de_wednesday = /** @type {(inputs: WednesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittwoch`)
};

/**
* | output |
* | --- |
* | "Wednesday" |
*
* @param {WednesdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wednesday = /** @type {((inputs?: WednesdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WednesdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wednesday(inputs)
	return de_wednesday(inputs)
});